import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import BooleanField from 'components/show/BooleanField';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import ImageContainer from 'pages/products/images/ImageContainer';
import InnerColumn from 'components/ui/show/InnerColumn';
import ListButton from 'components/button/ListButton';
import ProductModal from 'components/modals/product/ProductModal';
import ProductsTable from '../products/ProductsTable';
import Section from 'components/ui/general/Section';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import { createPointOfInterestImage } from 'store/actions/pointsofinterest/images/createPointsOfInterestImage';
import { deletePointOfInterestImage } from 'store/actions/pointsofinterest/images/deletePointsOfInterestImage';
import { fetchPointOfInterestImages } from 'store/actions/pointsofinterest/images/fetchPointsOfInterestImages';
import { setHighlightedPointsOfInterestImage } from 'store/actions/pointsofinterest/images/setHighlightedPointsOfInterestImage';

const PointsOfInterestShow = (props) => {
    const {
        data,
        handleAdd,
        handleRemove,
        id,
        translate,
    } = props;

    const breadcrumbs = [
        {
            label: translate('resources.points_of_interest.title'),
            link: '/pointsofinterest',
        },
        {
            label: data.name || data.id,
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ translate('resources.points_of_interest.actions.show', { title: data.name }) } />

                <Actions>
                    <EditButton url={ `/pointsofinterest/${ data.id }` } />

                    <ListButton url='/pointsofinterest' />
                </Actions>
            </Header>

            <Section>
                <Column size={ 12 }>
                    <InnerColumn>
                        <TextField
                            label='resources.points_of_interest.fields.id'
                            value={ data.id }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.type'
                            value={ data.type }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.street'
                            value={ data.street }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.street_number'
                            value={ data.street_number }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.city'
                            value={ data.city }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.state'
                            value={ data.state }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.zipcode'
                            value={ data.zipcode }
                        />

                        <TextField
                            label='resources.points_of_interest.fields.country'
                            value={ data.country }
                        />
                    </InnerColumn>
                    <InnerColumn>
                        <BooleanField
                            label='resources.points_of_interest.fields.is_highlighted'
                            value={ data.is_highlighted || false }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column title={ translate('general.images') }>
                    <InnerColumn>
                        <ImageContainer
                            action={ fetchPointOfInterestImages }
                            createAction={ createPointOfInterestImage }
                            deleteAction={ deletePointOfInterestImage }
                            highlightImageAction={ setHighlightedPointsOfInterestImage }
                            id={ `${ id }` }
                            record={ data }
                            showHighlightOption={ true }
                            source='pointsOfInterestImages'
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column
                    actions={
                        <ProductModal
                            data={ data }
                            handleAdd={ handleAdd }
                            source='promoted_products'
                            title='resources.points_of_interest.promoted_products.add'
                        />
                    }
                    title={ translate('resources.points_of_interest.promoted_products.title') }
                >
                    <InnerColumn>
                        <ProductsTable
                            data={ data }
                            handleRemove={ handleRemove }
                            noResultsLabel='resources.points_of_interest.promoted_products.no_results'
                            source='promoted_products'
                        />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

PointsOfInterestShow.propTypes = {
    data: PropTypes.object.isRequired,
    handleAdd: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    translate: PropTypes.func,
};

export default translate(PointsOfInterestShow);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/show/PointsOfInterestShow.js